import React, {useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './LeftPanel.module.css';
import PropTypes from 'prop-types';
import {useIsMobile} from '../../utils/utils'

import logoImg from "../../static_files/PrismaxLogoWhite.svg";
import transImg from '../../static_files/dashboard.svg';
import transImgHover from '../../static_files/dashboardHover.svg';
import assetsImg from '../../static_files/robot.svg';
import assetsImgHover from '../../static_files/robotHover.svg';
import c2cImg from '../../static_files/models.svg';
import c2cImgHover from '../../static_files/modelsHover.svg';
import inviteImg from '../../static_files/dataset.svg';
import bookImg from '../../static_files/bookIcon.svg';
import bookImgHover from '../../static_files/bookIconHover.svg';
import liveControlImg from '../../static_files/live control.svg';
import liveControlImgHover from '../../static_files/live controlHover.svg';

import badgeExplorerSvg from '../../static_files/badge_explorer.svg';
import badgeExplorerPng from '../../static_files/badge_explorer.png';
import badgeAmplifierSvg from '../../static_files/badge_amplifier.svg';
import badgeAmplifierPng from '../../static_files/badge_amplifier.png';
import badgeInnovatorSvg from '../../static_files/badge_innovator.svg';
import badgeInnovatorPng from '../../static_files/badge_innovator.png';

import expandImg from "../../static_files/left panel expand.svg";
import shrinkAccountImg from '../../static_files/Account icon.svg'
import TooltipRight from "../Tooltip/TooltipRight";
import {SwapMainAppContext} from "../../context/SwapMainAppContext";


const LeftPanel = ({
                       walletAddress,
                       onLoadingChange,
                       isTransactionPage = false,    // special treatment for transaction history page
                       isAutoShrink = false,           //to know if its the smaller  version
                       onPanelStateChange = (state) => {
                       },  // new call back
                   }) => {
    const isLargeScreen = useIsMobile(1265);
    const isSmallScreen = useIsMobile(767);

    const badge_explorer = isSmallScreen ? badgeExplorerPng : badgeExplorerSvg;
    const badge_amplifier = isSmallScreen ? badgeAmplifierPng : badgeAmplifierSvg;
    const badge_innovator = isSmallScreen ? badgeInnovatorPng : badgeInnovatorSvg;
    const {
        userClass,
        userEmail,
        shrinkLeftPanel,
        setShrinkLeftPanel
    } = useContext(SwapMainAppContext);
    const [currentPath, setCurrentPath] = useState('');
    const navigate = useNavigate();

    const location = useLocation();
    const [dashboardIsHovered, setDashboardIsHovered] = useState(false)
    const [robotFleetIsHovered, setRobotFleetIsHovered] = useState(false)
    const [datasetIsHovered, setDatasetIsHovered] = useState(false)
    const [modelsIsHovered, setModelsIsHovered] = useState(false)
    const [liveControlIsHovered, setLiveControlIsHovered] = useState(false)
    const [whitepaperIsHovered, setWhitepaperIsHovered] = useState(false)

    useEffect(() => {
        setCurrentPath(location.pathname);
        if (location.pathname === '/whitepaper') {
            setShrinkLeftPanel(true)
        }
    }, [location]);

    useEffect(() => {
        setCurrentPath(window.location.pathname);
    }, []);

    const handleToggleShrink = () => {
        setShrinkLeftPanel(prevState => {
            const newState = !prevState;
            localStorage.setItem('shrinkLeftPanel', JSON.stringify(newState));
            onPanelStateChange(newState);
            return newState;
        });
    };

    useEffect(() => {
        if (isAutoShrink || isLargeScreen) {
            setShrinkLeftPanel(true)
        }
    }, [isAutoShrink, isLargeScreen]);

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--panel-width',
            shrinkLeftPanel ? "60px" : "188px"
        );
    }, [shrinkLeftPanel]);


    const handleDashboardClick = () => {
        navigate(`/`);
    };
    const handleLiveControlClick = () => {
        navigate(`/live-control`);
    };
    const panelWidth = shrinkLeftPanel ? '92px' : '281px';

    return (
        <>
            <div
                className={styles.placeHolder}
                style={{
                    width: panelWidth,
                    transition: 'width 0.3s ease',
                    height: '100vh'
                }}
            />
            <div
                className={
                    shrinkLeftPanel
                        ? `${styles.shrinkLeftPanel} ${isTransactionPage ? styles.leftPanel2 : styles.leftPanel}`
                        : (isTransactionPage ? styles.leftPanel2 : styles.leftPanel)
                }
            >
                <div
                    className={styles.leftPanelContent}
                >
                    <div
                        className={styles.leftPanelInner}
                        style={{width: '100%'}}
                    >
                        {shrinkLeftPanel ?
                            <div
                                style={{display: 'flex', alignItems: 'center', height: '41px'}}>
                                <button className={styles.iconButton} onClick={handleToggleShrink}
                                        style={{marginLeft: '14px'}}>
                                    <img
                                        src={expandImg}
                                        alt="expandImg"
                                    />
                                </button>
                            </div>
                            : <div
                                style={{display: 'flex', alignItems: 'center', height: '41px'}}>
                                <img
                                    style={{cursor: 'pointer', marginLeft: '16px'}}
                                    className={styles.vectorIcon}
                                    alt="PrismaXAI"
                                    src={logoImg}
                                    onClick={() => window.open('https://prismax.ai/', '_blank')}
                                />
                                <button className={styles.iconButton} onClick={handleToggleShrink}>
                                    <img
                                        src={expandImg}
                                        alt="expandImg"
                                    />
                                </button>
                            </div>
                        }
                    </div>

                    {/* Menu */}
                    <div className={styles.leftMenu} style={{width: shrinkLeftPanel ? '60px' : '188px'}}>
                        <ul className={styles.leftOptionUl}
                            style={{width: shrinkLeftPanel ? '60px' : '240px'}}>
                            {/* Dashboard */}
                            <li
                                className={
                                    currentPath === '/'
                                        ? `${styles.leftOption} ${styles.activeGrey}`
                                        : styles.leftOption
                                }
                                onClick={handleDashboardClick}
                                onMouseEnter={() => setDashboardIsHovered(true)}
                                onMouseLeave={() => setDashboardIsHovered(false)}
                                style={{
                                    marginLeft: shrinkLeftPanel ? "4px" : '16px',
                                    marginRight: shrinkLeftPanel ? "4px" : "inherit",
                                    paddingLeft: shrinkLeftPanel ? "0" : "8px",
                                    justifyContent: shrinkLeftPanel ? 'center' : "inherit",
                                }}
                            >
                                {shrinkLeftPanel ?
                                    <TooltipRight text={<>Dashboard</>} backgroundColor={"#262626"}
                                                  borderRadius={"6px"}
                                                  height={'20px'}>
                                        <img
                                            className={styles.menuIcon}
                                            src={dashboardIsHovered || currentPath === '/' ? transImgHover : transImg}
                                            alt="Dashboard icon"
                                        />
                                    </TooltipRight> :
                                    <img
                                        className={`${styles.menuIcon} ${styles.iconTextGap}`}
                                        src={dashboardIsHovered || currentPath === '/' ? transImgHover : transImg}
                                        alt="Dashboard icon"
                                    />}

                                {!shrinkLeftPanel && "Dashboard"}

                            </li>

                            {/* Live Control */}
                            {/*<li*/}
                            {/*    className={*/}
                            {/*        currentPath === '/live-control' || currentPath === '/tele-op'*/}
                            {/*            ? `${styles.leftOption} ${styles.activeGrey}`*/}
                            {/*            : styles.leftOption*/}
                            {/*    }*/}
                            {/*    onClick={handleLiveControlClick}*/}
                            {/*    style={{*/}
                            {/*        marginLeft: shrinkLeftPanel ? "4px" : '16px',*/}
                            {/*        marginRight: shrinkLeftPanel ? "4px" : "inherit",*/}
                            {/*        paddingLeft: shrinkLeftPanel ? "0" : "8px",*/}
                            {/*        justifyContent: shrinkLeftPanel ? 'center' : "inherit",*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    {shrinkLeftPanel ?*/}
                            {/*        <TooltipRight text={<>Live Control</>} backgroundColor={"#262626"}*/}
                            {/*                      borderRadius={"6px"}*/}
                            {/*                      height={'20px'}>*/}
                            {/*            <img*/}
                            {/*                className={styles.menuIcon}*/}
                            {/*                src={liveControlImg}*/}
                            {/*                alt="Live Control icon"*/}
                            {/*            />*/}
                            {/*        </TooltipRight> :*/}
                            {/*        <img*/}
                            {/*            className={`${styles.menuIcon} ${styles.iconTextGap}`}*/}
                            {/*            src={liveControlImg}*/}
                            {/*            alt="Live Control icon"*/}
                            {/*        />}*/}

                            {/*    {!shrinkLeftPanel && "Live Control"}*/}

                            {/*</li>*/}

                            {/* Robot Fleet */}
                            <li
                                className={
                                    currentPath === '/fleet'
                                        ? `${styles.leftOption} ${styles.activeGrey}`
                                        : styles.leftOption
                                }
                                onClick={() => {
                                    navigate('/fleet');
                                }}
                                onMouseEnter={() => setRobotFleetIsHovered(true)}
                                onMouseLeave={() => setRobotFleetIsHovered(false)}
                                style={{
                                    marginLeft: shrinkLeftPanel ? "4px" : '16px',
                                    marginRight: shrinkLeftPanel ? "4px" : "inherit",
                                    paddingLeft: shrinkLeftPanel ? "0" : "8px",
                                    justifyContent: shrinkLeftPanel ? 'center' : "inherit",
                                }}
                            >
                                {shrinkLeftPanel ?
                                    <TooltipRight text={<>Robot Fleet</>} backgroundColor={"#262626"}
                                                  borderRadius={"6px"}>
                                        <img
                                            className={styles.menuIcon}
                                            src={robotFleetIsHovered || currentPath === '/fleet' ? assetsImgHover : assetsImg}
                                            alt="Robot Fleet icon"
                                        />
                                    </TooltipRight> :
                                    <img
                                        className={`${styles.menuIcon} ${styles.iconTextGap}`}
                                        src={robotFleetIsHovered || currentPath === '/fleet' ? assetsImgHover : assetsImg}
                                        alt="Robot Fleet icon"
                                    />}
                                {!shrinkLeftPanel && "Robot Fleet"}
                            </li>

                            <li
                                className={
                                    currentPath === '/Models'
                                        ? `${styles.leftOption} ${styles.activeGrey}`
                                        : styles.leftOption
                                }
                                // onClick={() => navigate('/Models')}
                                style={{
                                    marginLeft: shrinkLeftPanel ? "4px" : '16px',
                                    marginRight: shrinkLeftPanel ? "4px" : "inherit",
                                    paddingLeft: shrinkLeftPanel ? "0" : "8px",
                                    justifyContent: shrinkLeftPanel ? 'center' : "inherit",
                                }}
                                onMouseEnter={() => setModelsIsHovered(true)}
                                onMouseLeave={() => setModelsIsHovered(false)}
                            >
                                {shrinkLeftPanel ?
                                    <TooltipRight text={<>Coming Soon</>} backgroundColor={"#262626"}
                                                  borderRadius={"6px"}>
                                        <img
                                            className={styles.menuIcon}
                                            src={modelsIsHovered || currentPath === '/Models' ? c2cImgHover : c2cImg}
                                            alt="Models icon"
                                        />
                                    </TooltipRight> :
                                    <img
                                        className={`${styles.menuIcon} ${styles.iconTextGap}`}
                                        src={modelsIsHovered || currentPath === '/Models' ? c2cImgHover : c2cImg}
                                        alt="Models icon"
                                    />}
                                {!shrinkLeftPanel && "Models"}
                                {!shrinkLeftPanel && modelsIsHovered && <span className={styles.comingSoon} style={{
                                    marginLeft: 'auto',
                                    fontSize: '12px',
                                    color: '#666'
                                }}>(Coming Soon)</span>}

                            </li>


                            {/* Dataset Library */}
                            <li className={
                                currentPath === '/dataset'
                                    ? `${styles.leftOption} ${styles.activeGrey}`
                                    : styles.leftOption
                            }
                                // onClick={() => navigate('/dataset')}
                                style={{
                                    marginLeft: shrinkLeftPanel ? "4px" : '16px',
                                    marginRight: shrinkLeftPanel ? "4px" : "inherit",
                                    paddingLeft: shrinkLeftPanel ? "0" : "8px",
                                    justifyContent: shrinkLeftPanel ? 'center' : "inherit",
                                }}
                                onMouseEnter={() => setLiveControlIsHovered(true)}
                                onMouseLeave={() => setLiveControlIsHovered(false)}
                            >
                                {shrinkLeftPanel ?
                                    <TooltipRight text={<>Coming Soon</>} backgroundColor={"#262626"}
                                                  borderRadius={"6px"}>
                                        <img
                                            className={styles.menuIcon}
                                            src={liveControlIsHovered || currentPath === '/dataset' ? liveControlImgHover : liveControlImg}
                                            alt="Live Control icon"
                                        />
                                    </TooltipRight> :
                                    <img
                                        className={`${styles.menuIcon} ${styles.iconTextGap}`}
                                        src={liveControlIsHovered || currentPath === '/dataset' ? liveControlImgHover : liveControlImg}
                                        alt="Live Control icon"
                                    />}
                                {!shrinkLeftPanel && "Live Control"}
                                {!shrinkLeftPanel && liveControlIsHovered && <span className={styles.comingSoon} style={{
                                    marginLeft: 'auto',
                                    fontSize: '12px',
                                    color: '#666'
                                }}>(Coming Soon)</span>}
                            </li>

                            {
                                shrinkLeftPanel ? <div className={styles.shrinkDivider}></div> :
                                    <div className={styles.divider}></div>
                            }

                            {/* whitepaper */}
                            <li
                                className={
                                    currentPath === '/whitepaper'
                                        ? `${styles.leftOption} ${styles.activeGrey} ${styles.whitepaperText}`
                                        : `${styles.leftOption} ${styles.whitepaperText}`
                                }
                                onClick={() => {
                                    navigate('/whitepaper');
                                }}
                                onMouseEnter={() => setWhitepaperIsHovered(true)}
                                onMouseLeave={() => setWhitepaperIsHovered(false)}
                                style={{
                                    marginLeft: shrinkLeftPanel ? "4px" : '16px',
                                    marginRight: shrinkLeftPanel ? "4px" : "inherit",
                                    paddingLeft: shrinkLeftPanel ? "0" : "8px",
                                    justifyContent: shrinkLeftPanel ? 'center' : "inherit",
                                    color: whitepaperIsHovered || currentPath === '/whitepaper' ? "#FFC786" : "#B9986A"
                                }}
                            >
                                {shrinkLeftPanel ?
                                    <TooltipRight text={<>WhitePaper</>} backgroundColor={"#262626"}
                                                  borderRadius={"6px"}>
                                        <img
                                            className={styles.menuIcon}
                                            src={whitepaperIsHovered || currentPath === '/whitepaper' ? bookImgHover : bookImg}
                                            alt="WhitePaper icon"
                                        />
                                    </TooltipRight> :
                                    <img
                                        className={`${styles.menuIcon} ${styles.iconTextGap}`}
                                        src={whitepaperIsHovered || currentPath === '/whitepaper' ? bookImgHover : bookImg}
                                        alt="WhitePaper icon"
                                    />}
                                {!shrinkLeftPanel && "Whitepaper"}
                            </li>

                        </ul>
                    </div>


                    {/* Account */}

                    <div className={styles.leftMenu} style={{width: shrinkLeftPanel ? '59.5px' : '188px'}}>
                        <div
                            className={`${styles.accountOuterContainer} ${shrinkLeftPanel ? styles.shrinkAccountContainer : ''}`}>

                            <div
                                className={
                                    `${styles.accountContainer} ` +
                                    `${currentPath === '/account' ? styles.activeaccountContainer : ''}`
                                }
                                onClick={() => navigate('/account')}
                                style={{
                                    width: shrinkLeftPanel ? '52px' : '224px',
                                    left: shrinkLeftPanel ? '36px' : '48px',
                                    paddingLeft: shrinkAccountImg ? '6px' : '',
                                    backgroundColor: shrinkLeftPanel ? 'transparent' : '#DFD8D0'
                                }}

                            >
                                <img
                                    className={styles.accountIcon}
                                    src={userClass === 'Amplifier Member' ?
                                        badge_amplifier : (userClass === 'Innovator Member' ? badge_innovator : badge_explorer)}
                                    alt="account icon"
                                />
                                {!shrinkLeftPanel && (<p>{userEmail ? userEmail : 'Account'}</p>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

LeftPanel.propTypes = {
    walletAddress: PropTypes.string, // Optional prop
    onLoadingChange: PropTypes.func // Optional prop

};

export default LeftPanel;